import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageComponent from "../Layouts/ImageComponent";
import _ from "lodash";
import { useState } from "react";
import CartPopUpComponent from "../NewDesign/DetailPage/CartPopUp/CartPopUpComponent";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import useLogin from "../../custom-hooks/useLogin";
import { getFileTypeName } from "../../utils/AppUtils";

const ModuleSingleCardComponent = (props) => {

    const {
        index, item, navigateToDetails, productData, hasTeaser,
        setIsLoading
    } = props

    const [isOpen, setIsOpen] = useState(false)
    const { isLoggedIn } = useLogin()

    return (
        <>
            <div className="modulesection" id={`module-crs-${item.module_id}`}>
                <span className="module-title">
                    {"Module " + (index + 1)}
                </span>

                <h3 style={{ color: "black" }}>{item.title}</h3>
                <ul className="moduleinner-list">
                    <li>
                        {
                            // !_.isEmpty(item.rsp_toolkit) &&
                            // _.isArray(item.rsp_toolkit)
                            // ? item.rsp_toolkit[0].title
                            // : 
                            getFileTypeName(item.file_type)}
                    </li>
                    <li>{item.durationTime}</li>
                </ul>
                <div className="image-blocklp">
                {item?.is_updated ? <div className="new-tag"><span className="new-tag-ribbon">Updated</span></div> : ""}
                <ImageComponent
                    thumbnail={
                        item.thumbnail ? item.thumbnail : ""
                    }
                    name={item.title}
                    cssClass={`img-fluid galleryImg ${item.isLock ? "grayscale" : ""
                        }`}
                    errorClass={`img-fluid grayscale d-flex justify-content-center align-items-center bk-grey ${item.isLock ? "grayscale" : ""
                        }`}
                />
                </div>

                <OverlayTrigger
                    key="bottom"
                    placement="top-start"
                    overlay={
                        <Tooltip id={`tooltip-bottom`}>
                            <div
                                style={{
                                    color: "white",
                                    backgroundColor: "black",
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: item?.desc,
                                }}
                            ></div>
                        </Tooltip>
                    }
                >
                    <div className="discription-detail"
                        dangerouslySetInnerHTML={{
                            __html:item.desc,
                        }}
                    ></div>
                </OverlayTrigger>

                <div className="progress-rowsec">
                    <div className="d-flex gap-3 progress-content position-relative">
                        <div className="progress-rowbar">
                            <div
                                className="progress"
                                role="progressbar"
                                aria-label="Basic example"
                                aria-valuenow={item.progress}
                                aria-valuemin="0"
                                aria-valuemax="100"
                            >
                                <div
                                    className="progress-bar"
                                    style={{ width: item.progress + "%" }}
                                ></div>
                            </div>
                        </div>
                        <span className="progress-text">
                            {_.isNumber(item?.progress) ? item?.progress : item?.progress?.split(".")[0]}%
                        </span>
                    </div>
                    {
                        productData.isLoadingPriceInfo ?
                            <ShimmerScreen
                                width="8rem"
                                height="2rem"
                                case="rect"
                            />
                            :
                            <>
                                {
                                productData.isPaid ?
                                    hasTeaser
                                        ?
                                        <button
                                            type="button"
                                            className={`${item.isLock
                                                ? "startcourse-btn cursor-not-allowed"
                                                : "startcourse-btn cursor-pointer"
                                                }`}
                                            onClick={() => {
                                                navigateToDetails(
                                                    item.title,
                                                    item.progress,
                                                    item
                                                );
                                            }}
                                        >
                                            {item.progress > 0
                                                ? "Restart module"
                                                : "Free trail Access"}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331" stroke="#6941C6" strokeWidth="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                        </button>
                                        :
                                        <button
                                            type="button"
                                            className="startcourse-btn cursor-pointer"
                                            onClick={() => {
                                                setIsOpen(true)
                                            }}
                                        >
                                            Purchase to unlock
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331" stroke="#6941C6" strokeWidth="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                        </button>
                                    :
                                    <button
                                        type="button"
                                        className={`${item.isLock
                                            ? "startcourse-btn cursor-not-allowed"
                                            : "startcourse-btn cursor-pointer"
                                            }`}
                                        onClick={() => {
                                            navigateToDetails(
                                                item.title,
                                                item.progress,
                                                item
                                            );
                                        }}
                                    >
                                        {item.progress > 0
                                            ? item.progress < 100 ? "Resume module" : "Restart module"
                                            : "Start module"}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331" stroke="#6941C6" strokeWidth="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                    </button>
                                }
                            </>
                    }
                </div>
            </div>
            <CartPopUpComponent
                isOpen={isOpen}
                productData={productData}
                closeAction={() => setIsOpen(false)}
                isSubscription={false}
                setMainPageLoading={setIsLoading}
            />
        </>
    )
}

export default ModuleSingleCardComponent